<header class="text-center my-16">
	<h1 class="text-4xl font-bold">lossless2opus</h1>
	<p class="text-neutral-400">fast convert .flac to .opus easily</p>
</header>
